export default __webpack_public_path__ + "static/media/double-peak.26d1d622.png";